<template>
  <div id="app" :class="{enable: bg_color}">
    <div v-if="error404" class="w3-center" style="font-size: 50px">
      <br><br><br>
      404<br>
      Page not found!
    </div>

    <div v-else>
      <Navbar v-show="!$route.params.slug" />
      <router-view/>
    </div>

    <!-- {{$route}} -->
<!--
    <button class="btn btn-outline-primary" v-on:click="$toast.show('Welcome!', 'Hey', notificationSystem.options.show)">Show</button>&nbsp;
    <button class="btn btn-outline-secondary" v-on:click="$toast.show('Welcome!', 'Hey', notificationSystem.options.ballon)">Ballon</button>&nbsp;
    <button class="btn btn-outline-info" v-on:click="$toast.info('Welcome!', 'Hello', notificationSystem.options.info)">Info</button>&nbsp;
    <button class="btn btn-outline-success" v-on:click="$toast.success('Successfully inserted record!', 'OK', notificationSystem.options.success)">Success</button>&nbsp;
    <button class="btn btn-outline-warning" v-on:click="$toast.warning('You forgot important data', 'Caution', notificationSystem.options.warning)">Warning</button>&nbsp;
    <button class="btn btn-outline-danger" v-on:click="$toast.error('Illegal operation', 'Error', notificationSystem.options.error)">Error</button>&nbsp;
    <button class="btn btn-outline-dark" v-on:click="$toast.question('Are you sure about that?', 'Hey', notificationSystem.options.question)">Question</button>
 -->
    <!-- <svg fill="#6B6F76" width="16" height="16" viewBox="0 0 16 16">
      <rect x="1" y="8" width="3" height="6" rx="1"></rect>
      <rect x="6" y="5" width="3" height="9" rx="1"></rect>
      <rect x="11" y="2" width="3" height="12" rx="1" fill-opacity="0.1"></rect>
    </svg> -->
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import axios from 'axios'
import router from '@/router'
import Navbar from './components/Navbar.vue'


import NProgress from 'nprogress'
// import 'nprogress/nprogress.css'

export default {

  data() {
    return {
      bg_color: false,
      error404: null,
      notificationSystem: {
        options: {

          ballon: {
            balloon: true,
            position: "bottomRight"
          },
          info: {
            position: "bottomLeft"
          },
          success: {
            position: "bottomRight"
          },
          warning: {
            position: "topLeft"
          },
          error: {
            position: "topRight"
          },
          question: {
            timeout: 20000,
            close: false,
            overlay: true,
            toastOnce: true,
            id: "question",
            zindex: 999,
            position: "center",
            buttons: [
              [
                "<button><b>YES ooo!</b></button>",
                function(instance, toast) {
                  instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                },
                true
              ],
              [
                "<button>NO</button>",
                function(instance, toast) {
                  instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                }
              ]
            ],
            onClosing: function(instance, toast, closedBy) {
              console.info("Closing | closedBy: " + closedBy);
            },
            onClosed: function(instance, toast, closedBy) {
              console.info("Closed | closedBy: " + closedBy);
            }
          }
        }
      }
    };
  },

  methods: {
    ...mapActions('auth', ['logout', 'fetchWorkspaceInvites']),

    logoutUser: function () {
      this.logout()
    },

    workspaceData: function(){
      return this.currentWorkspaceData;
    },

    handleConnectivityChange(status) {
      console.log(status);
    }
  },

  watch: {
    $route (to, from){
      this.bg_color = false

      if (to.params.slug) {
        const result = this.workspaces.find( ({ slug }) => slug === to.params.slug );
        if(!result){ router.push({name: '404ws'}) }
      }

      if (to.params.issueslug) {
        const result = this.ws_issues.find( ({ slug }) => slug === to.params.issueslug );
        if(!result){
          // router.push({name: '404'})
          this.error404 = true
        }else{
          this.error404 = false
        }
      }

      console.log(this.$route.name);

      const dark_pages = ['home', 'about', 'login', 'signup', 'accountrecovery', 'accountreset', 'accountresetsuccess', 'joinworkspace', '404ws', 'welcome', '404']
      if (dark_pages.includes(this.$route.name)) {
        this.bg_color = true
      }
    }
  },

  components: {
    Navbar,
  },

  created: function () {
    const dark_pages = ['home', 'about', 'login', 'signup', 'accountrecovery', 'accountreset', 'accountresetsuccess', 'joinworkspace', '404ws', 'welcome', '404']
    if (dark_pages.includes(this.$route.name)) {
      this.bg_color = true
    }
    // alert($route.path);
    // console.log(this.$route.params.slug);
    // console.log(this.workspaceData());
    // console.log(this.$router.currentRoute.fullPath);
    if (this.isLoggedIn) {
      // this.fetchWorkspaceInvites({ user_id: this.user.id })
    }

    // // before a request is made start the nprogress
    // axios.interceptors.request.use(config => {
    //   NProgress.start()
    //   return config
    // })
    //
    // // before a response is returned stop nprogress
    // axios.interceptors.response.use(response => {
    //   NProgress.done()
    //   return response
    // })

  },

  mounted: function () {
    if (localStorage.getItem('loginContinue') && this.isLoggedIn) {
      localStorage.removeItem('loginContinue')
    }
  },


  computed: {
    ...mapState('auth', ['background_color']),
    ...mapGetters('auth', ['auth_state', 'user', 'isLoggedIn', 'workspaces']),
    ...mapGetters('workspace', ['ws_issues']),
    // currentWorkspaceData: function(){
    //   const result = this.workspaces.find( ({ slug }) => slug === this.$route.params.slug );
    //   return result;
    // }
  }
}

</script>

<style>
html{
  width: 100%;
  height:100%;
  margin: 0;
  /* background-color: #121212;
  color: white; */
  /* overflow:hidden; */
}

.enable{
  /* background-color: #121212; */
  /* background: linear-gradient(95deg, #121212, #6078ea); */
  background-color: #161822;
  color: white;
  width: 100%;
  min-height:100vh;
  margin: 0;
}

a{
  text-decoration: none;
}

body{
  width: 100%;
  height:100;
  margin: 0;
}

#app {
  /* font-family: 'Montserrat', sans-serif; */
  font-family: 'Work Sans', sans-serif;
  /* text-align: center; */
}

.editable{
  /* background-color: red; */
  max-height: 410px;
  max-width: 100%;
  word-wrap:break-word;
  overflow-y: auto
}

.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}

.err{
  text-transform: capitalise
}

.light-text{
  color: #2c3e50;
}

.light-text2{
  color: #95a2b3
}

.light-text3{
  color: #6b6f76;
}

.yellow{
  color: #FFC300;
}

.xsmall{
  font-size: 8px;
}

.purple{
  color: #5d6ad2;
}

#nprogress .bar {
  height: 5px;
}

.sub-head{
  border-bottom: 1px solid #f3efee;
  background-color:#f8f9fb
}


/* #container {
  padding:40px;
  background-color:grey;
  color:white;
} */

#nprogress .bar {
  /* background: purple; */
  background: #827ffe;
}

#nprogress .spinner-icon {
  border-top-color: #827ffe;
  border-left-color: #827ffe;
}

.over-flow {
  max-width: auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>
